"use client";
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import Icon from "../../graphics/Icon/Icon.js";
import { resolveIconColor } from "../../graphics/Icon/Icon.helpers.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { useMantineTheme, rem, List as List$1 } from "@mantine/core";
import { forwardRef } from "react";
import '../../../assets/List.css';const root = "_root_1qwki_2";
const item = "_item_1qwki_9";
const itemWrapper = "_itemWrapper_1qwki_17";
const ListStyles = {
  root,
  item,
  itemWrapper
};
const _List = forwardRef((props, ref) => {
  const {
    items,
    size = "md",
    center = true,
    spacing,
    icon,
    iconColor = "dark",
    iconSize = "md",
    withPadding,
    style,
    lineHeight,
    type = "unordered",
    ...rest
  } = props;
  const hasNestedList = Boolean(items.find((item2) => item2.nested));
  const theme = useMantineTheme();
  const styleVariables = {
    "--passed-line-height": lineHeight ? theme.spacing[lineHeight] : rem("30px"),
    "--passed-icon-color": iconColor ? resolveIconColor(iconColor) : "var(--figurine-icons-dark)"
  };
  const getNextLevel = (level, padding) => /* @__PURE__ */ jsx(
    List$1,
    {
      ...rest,
      ref,
      size,
      spacing,
      withPadding: padding,
      icon: !hasNestedList && icon && /* @__PURE__ */ jsx(Icon, { name: icon, color: iconColor, size: iconSize }),
      classNames: ListStyles,
      type,
      center,
      style: { ...styleVariables, ...style },
      children: level.map((item2) => /* @__PURE__ */ jsxs(
        List$1.Item,
        {
          icon: !hasNestedList && item2.icon && /* @__PURE__ */ jsx(Icon, { name: item2.icon, color: item2.iconColor || iconColor }),
          children: [
            item2.text,
            item2.description,
            item2.nested && getNextLevel(item2.nested, true)
          ]
        },
        `${item2.text}-${Math.random()}`
      ))
    }
  );
  return /* @__PURE__ */ jsx(Fragment, { children: getNextLevel(items, withPadding) });
});
_List.displayName = "List";
const List = sharedHandler(_List);
List.displayName = _List.displayName;
export {
  ListStyles as L,
  List as default
};
